import { Meta, TQueryOptions } from "@/@types/axios";
import {
  TOrganization,
  TOrganizationParamsType,
} from "@/features/organizations/types";
import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";

export type TOrganizationsListResponse = {
  items: TOrganization[];
  meta: Meta;
};

const useGeTOrganizations = (
  params: TOrganizationParamsType,
  options?: TQueryOptions,
) => {
  return useQuery({
    queryKey: ["organization-list", params],
    queryFn: () =>
      MyAxios.get<TOrganizationsListResponse>("/organizations", {
        params,
      }),
    ...options,
  });
};

export default useGeTOrganizations;
